import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Tabs, TabsContent, TabsList, TabsTrigger } from "./ui/tabs";
import WorkspaceContacts from './WorkspaceContacts';
import GlobalContacts from './GlobalContacts';
import { Globe, Users, Database } from 'lucide-react';
import PageHeader from './ui/PageHeader';
import PageShell from './ui/PageShell';
import { useTour } from './ui/TourManager';
import { contactsTourSteps } from './ui/tourSteps';

export default function Contacts() {
    const [searchParams] = useSearchParams();
    // We default to workspace as requested by product rules.
    const [activeTab, setActiveTab] = useState(searchParams.get('tab') || 'workspace');
    const { startTour } = useTour();

    // Auto-start tour on first visit
    useEffect(() => {
        const tourShown = localStorage.getItem('contactsTourShown');
        if (tourShown !== 'true') {
            startTour('contacts', contactsTourSteps);
        }
    }, [startTour]);

    // Handle navigation-time deep-links (e.g. when already on this route)
    useEffect(() => {
        if (searchParams.get('focus')) {
            setActiveTab('workspace');
        }
    }, [searchParams]);

    return (
        <PageShell>
            <div className="contacts-header">
            <PageHeader
                title="Contacts"
                subtitle="Manage your local Workspace records or discover new prospects from the Global Pool."
                icon={Users}
                actions={
                  <button
                    onClick={() => startTour('contacts', contactsTourSteps)}
                    className="border-primary/30 text-primary hover:bg-primary/5 px-4 py-3 rounded-xl shadow-sm text-sm font-bold flex items-center transition-all border"
                    title="Start Tour"
                  >
                    <Users className="w-4 h-4 mr-2" />
                    Tour
                  </button>
                }
            />
            </div>

            <Tabs value={activeTab} onValueChange={setActiveTab} className="contacts-table w-full">
                <div className="flex items-center justify-between mb-8 overflow-x-auto pb-2 scrollbar-hide">
                    <TabsList className="bg-muted/50 p-1.5 rounded-2xl border border-border/50 h-auto">
                        <TabsTrigger 
                            value="global" 
                            className="rounded-xl font-black text-[10px] uppercase tracking-widest flex items-center gap-2.5 px-6 py-2.5 data-[state=active]:bg-background data-[state=active]:shadow-lg data-[state=active]:text-primary transition-all"
                        >
                            <Globe className="w-4 h-4" /> Global Discovery Pool
                        </TabsTrigger>
                        <TabsTrigger 
                            value="workspace" 
                            className="rounded-xl font-black text-[10px] uppercase tracking-widest flex items-center gap-2.5 px-6 py-2.5 data-[state=active]:bg-background data-[state=active]:shadow-lg data-[state=active]:text-primary transition-all"
                        >
                            <Database className="w-4 h-4" /> Workspace CRM
                        </TabsTrigger>
                    </TabsList>
                </div>

                <TabsContent value="global" className="mt-0 outline-none animate-in fade-in slide-in-from-bottom-2 duration-500">
                    <GlobalContacts  />
                </TabsContent>

                <TabsContent value="workspace" className="mt-0 outline-none animate-in fade-in slide-in-from-bottom-2 duration-500">
                    <WorkspaceContacts />
                </TabsContent>
            </Tabs>
        </PageShell>
    );
}
